import * as Yup from 'yup';
import { VALIDATION_REQUIRED } from '../../config';

export default Yup.object().shape({
  content: Yup.string().required(VALIDATION_REQUIRED)
});
